import request from '@/plugins/request';
import { IBoolResult, IErrorResult } from '@/types/dto';
import { IHost, IExtension } from '@/types/models';
import utils from '@/utils';
import { AxiosError, AxiosResponse } from 'axios';

const $url = '/my/plugins';
const $urlGetHosts = '/my/plugins/actions/getHosts';
const $urlGetExtension = '/my/plugins/actions/getExtension';
const $urlBuy = '/my/plugins/actions/buy';
const $urlPay = '/my/plugins/actions/pay';
const $urlQuery = '/my/plugins/actions/query';
const $urlDeploy = '/my/plugins/actions/deploy';

interface IGetRequest {
  type: string;
}

interface IGetResult {
  extensions: IExtension[];
  orderResourceIds: string[];
  userName: string;
  isHostExists: boolean;
}

interface IDeleteRequest {
  name: string;
}

interface IGetHostsRequest {
  userName: string;
  name: string;
}

interface IGetHostsResult {
  hosts: IHost[];
  extension: IExtension;
}

interface IGetExtensionRequest {
  userName: string;
  name: string;
}

interface IGetExtensionResult {
  extensionDownloadUrl: string;
  guid: string;
}

interface IBuyRequest {
  userName: string;
  name: string;
}

interface IBuyResult {
  extensionUrl: string;
  price: number;
  discount: number;
}

interface IPayRequest {
  userName: string;
  name: string;
  channel: string;
  amount: number;
}

interface IPayResult {
  orderNo: string;
  qrCodeUrl: string;
}

interface IQueryRequest {
  orderNo: string;
}

interface IQueryResult {
  isPurchased: boolean;
}

interface IDeployRequest {
  userName: string;
  name: string;
  hostId: number;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, { params: req })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getHosts(req: IGetHostsRequest, success: (res: IGetHostsResult) => void) {
    utils.loading(true);
    request
      .get($urlGetHosts, {
        params: req,
      })
      .then((response: AxiosResponse<IGetHostsResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getExtension(req: IGetExtensionRequest, success: (res: IGetExtensionResult) => void) {
    utils.loading(true);
    request
      .post($urlGetExtension, req)
      .then((response: AxiosResponse<IGetExtensionResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  buy(req: IBuyRequest, success: (res: IBuyResult) => void) {
    utils.loading(true);
    request
      .post($urlBuy, req)
      .then((response: AxiosResponse<IBuyResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  pay(req: IPayRequest, success: (res: IPayResult) => void, failure: (error: AxiosError<IErrorResult> | string) => void) {
    utils.loading(true);
    request
      .post($urlPay, req)
      .then((response: AxiosResponse<IPayResult>) => {
        success(response.data);
        utils.loading(false);
      })
      .catch(error => {
        failure(error);
      });
  },

  query(req: IQueryRequest, success: (res: IQueryResult) => void) {
    request
      .post($urlQuery, req)
      .then((response: AxiosResponse<IQueryResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  deploy(req: IDeployRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlDeploy, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
